import { makeStyles } from 'tss-react/mui';

 const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
  }
}));

export default useStyles;